let _geocoder;

class MaverickGeocoding {
  constructor() {
    _geocoder = new google.maps.Geocoder();
  }

  geocode(latLng) {
    return new Promise((resolve, reject) => {
      _geocoder.geocode({
          location: latLng
        },
        (results, status) => {
          if (status === "OK") {
            const result = results[0];
            const address = result.formatted_address;
            let name = '';
            if (result.address_components !== undefined && result.address_components !== null && result.address_components.length > 0) {
              let administrative_area_level_4 = '';
              let administrative_area_level_3 = '';
              let administrative_area_level_2 = '';
              let administrative_area_level_1 = '';
              let country = '';
              for (let index = 0; index < result.address_components.length; index++) {
                const addressComponent = result.address_components[index];
                if (addressComponent.types.includes('administrative_area_level_4')) {
                  administrative_area_level_4 = addressComponent.long_name;
                } else if (addressComponent.types.includes('administrative_area_level_3')) {
                  administrative_area_level_3 = addressComponent.long_name;
                } else if (addressComponent.types.includes('administrative_area_level_2')) {
                  administrative_area_level_2 = addressComponent.long_name;
                } else if (addressComponent.types.includes('administrative_area_level_1')) {
                  administrative_area_level_1 = addressComponent.long_name;
                } else if (addressComponent.types.includes('country')) {
                  country = addressComponent.long_name;
                }
              }
              if (administrative_area_level_4 !== '') {
                name = administrative_area_level_4
              } else if (administrative_area_level_3 !== '') {
                name = administrative_area_level_3
              } else if (administrative_area_level_2 !== '') {
                name = administrative_area_level_2
              } else {
                name = address.split(',')[0];
              }

              // append city and country
              if (administrative_area_level_1 !== '' && country !== '') {
                name += `, ${administrative_area_level_1}, ${country}`
              }
            }
            resolve({
              address: address,
              name: name,
              latitude: latLng.lat,
              longitude: latLng.lng
            });
          } else {
            reject()
          }
        }
      );
    });
  }
}

export default MaverickGeocoding;



// WEBPACK FOOTER //
// ./src/plugins/google/geocode.js